<template>
	<div>
		<div v-if="auth">
			<div class="mt-2 text-center">
				<v-btn v-if="area === 'admin'" small outlined color="primary" @click="manualDialog = true">
					تکمیل اطلاعات قرارداد
				</v-btn>
			</div>
			<div class="mt-2 text-center">
				<v-btn small outlined color="primary" @click="contractDialog = true">
					مشاهده قرارداد
				</v-btn>
			</div>
			<div class="mt-2 text-justify contract" v-if="auth.tag" v-html="auth.tag">

			</div>
		</div>
		<div v-if="auth.memberDescription === 'signed'" class="d-flex px-2 align-center" style="width:170px">
			<v-text-field v-model="mobileOtp" maxlength="5" label="کد تایید" :rules="[() => !!mobileOtp || 'الزامی']" required />
			<v-btn v-if="sendCodeVisible" small class="mr-2" @click="sendOTP" :loading="optLoading"><small>ارسال کد</small></v-btn>
			<Countdown class="black--text fs-h3" @finish="countDownFinished" ref="countdown" />
		</div>

		<v-dialog v-model="contractDialog" max-width="1600px">
			<v-card color="#eee">
				<v-card-title>
					<div>
						<span class="headline">اطلاعات قرارداد</span>
					</div>
					<v-spacer />
					<v-btn @click="contractDialog = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-divider></v-divider>
				<v-card-text>
					<ContractDetail v-if="contractDialog" :area="area" :auth="auth" :mobile="mobile" :member="member" @updated="$emit('updated')" />
				</v-card-text>
			</v-card>
		</v-dialog>

		<v-dialog v-model="manualDialog" max-width="500px" scrollable>
			<v-card>
				<v-card-title>
					<div>
						<span class="headline">اطلاعات دستی قرارداد</span>
					</div>
					<v-spacer />
					<v-btn @click="manualDialog = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-divider></v-divider>
				<v-card-text>
					<div v-if="manualFields.length" class="mt-5">
						<v-text-field v-for="(field, index) in manualFields" :key="field.id || index" v-model="field.value" :label="field.label" dense outlined />
					</div>
					<div v-else class="text-center grey--text">
						موردی برای نمایش وجود ندارد.
					</div>
				</v-card-text>
				<v-divider></v-divider>
				<v-card-actions>
					<v-spacer />
					<v-btn text @click="manualDialog = false">
						بستن
					</v-btn>
					<v-btn color="secondary" :loading="submitManualTagsLoading" @click="submitManualTags">به روز رسانی متن قرارداد</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

	</div>
</template>

<script>
	import api from '@/util/app-api'
	import { get } from 'vuex-pathify'
	import toast from '@/util/toast'
	import { auth } from '@/store/modules'

	export default {
		name: 'DigitalSignSms',
		props: {
			member: { type: Object, default: null },
			auth: { type: Object, default: null },
			area: { type: String, default: 'member' },
		},
		data() {
			return {
				mobileOtp: '',
				sendCodeVisible: true,
				optLoading: false,
				submitManualTagsLoading: false,
				manualDialog: false,
				contractDialog: false,
				manualFields: [],
				mobilee: ''
			}
		},
		components: {
			Countdown: () => import('@/components/Countdown'),
			ContractDetail: () => import('@/components/loanAuthorizations/ContractDetail')
		},
		computed: {
			authorizationDescription() {
				return (this.auth && this.auth.authorizationItem && this.auth.authorizationItem.description) || ''
			},
			mobile() {
				return this.mobilee || this.member?.mobile || 'نامشخص'
			}
		},
		watch: {
			authorizationDescription: {
				immediate: true,
				handler(description) {
					this.extractManualFields(description)
				}
			}
		},
		mounted() {
			if (this.area === 'member')
				this.loadMemberMobile()
		},
		methods: {
			loadMemberMobile() {
				api.get('member/user/get/', null)
					.then(
						response => {
							this.mobilee = response.mobile
						})
					.catch(err => {
						toast.error(err.message)
					})
			},
			extractManualFields(description) {
				const fields = []
				if (!description) {
					this.manualFields = fields
					return
				}
				const regex = /\{manual:"([^"]+)"\}/g
				const prevFields = this.manualFields || []
				let match
				while ((match = regex.exec(description)) !== null) {
					const label = match[1]
					const index = fields.length
					fields.push({
						id: `${match.index}-${label}-${index}`,
						label,
						value: prevFields[index]?.value || ''
					})
				}
				this.manualFields = fields
			},
			countDownFinished() {
				this.sendCodeVisible = true
			},
			sendOTP() {
				if (!this.localData.mobile) {
					toast.error('شماره موبایل وارد نشده است')
					return
				}
				this.optLoading = true
				api.post('account/SendOTP/' + this.localData.mobile, {})
					.then(response => {
						this.sendCodeVisible = false
						this.$refs.countdown.start()
					})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(() => {
						this.optLoading = false
					})
			},
			submitManualTags() {
				this.submitManualTagsLoading = true
				const manualFieldsObj = this.manualFields.reduce((acc, field) => {
					acc[field.label] = field.value
					return acc
				}, {})
				api.post('admin/UserLoanRequestAuthorizationItem/UpdateDigitalSignDescription/', { manualFields: manualFieldsObj, userLoanRequestAuthorizationItemId: this.auth.id })
					.then(response => {
						this.manualDialog = false
						toast.success('اطلاعات قرارداد با موفقیت ثبت شد.')
						this.$emit('updated')
					})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(() => {
						this.submitManualTagsLoading = false
					})
			}
		}
	}
</script>
<style scoped>
	.contract b {
		font-weight: 900;
		border-bottom: 1px dotted blue;
		color: blue;
	}
</style>
